<div class="container">
  <div class="row footer">
    <div class="col-4">
      <p class="text-white">
        Copyright 2019 - {{ now }}
        <a class="text-white" target="_blank" href="https://confluence.sp.vodafone.com/spaces/MCCH/pages/767863008/Public+Cloud+Services">vodafone.com</a>
      </p>
    </div>
    <div class="col-2">
      <p class="text-white float-end">
        <a href="#" (click)="showPrivacyNotice($event)" class="clickable text-white">Privacy Policy</a>
      </p>
    </div>
    <div class="col-2">
      <p class="text-white float-end">
        <a href="#" (click)="showLegalNotice($event)" class="clickable text-white">Legal</a>
      </p>
    </div>
    <div class="col-2">
      <p class="text-white float-end">
        <a target="_blank" href="/3rdpartylicenses.txt" class="clickable text-white">Licences</a>
      </p>
    </div>
    <div class="col-2">
      <p class="text-white float-end">
        <a routerLink="/changelog" class="clickable text-white">1.122.0 - 2026-10-15</a>
      </p>
    </div>
  </div>
</div>
